export default {"src":"/_next/static/media/streaming.db5491a8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};